// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__CDli8","active":"Tab_active__hMxJQ","show":"Tab_show__2FqOe","none":"Tab_none__72FV1"};